import { Controller } from "@hotwired/stimulus"
import { confirmDialog, successDialog, errorDialog } from '../helpers/swal_helper';

export default class extends Controller {
  static targets = ["form", "list", "count", "nocmt"]

  add(event) {
    event.preventDefault()
    const [data, status, xhr] = event.detail

    // Prepend the new comment
    this.listTarget.insertAdjacentHTML('afterbegin', xhr.response)

    // Fade in the comment
    const newComment = this.listTarget.firstElementChild

    this.fadeInAndShow(newComment);

    // Increment the counter
    this.countTarget.textContent = parseInt(this.countTarget.textContent) + 1

    // Reset the form
    this.formTarget.reset()

    // Hide "no comments" message
    if (this.hasNocmtTarget) {
      this.nocmtTarget.classList.add('d-none')
    }
  }

  delete(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const url = button.dataset.url;

    confirmDialog({ text: "This Comment will be deleted." })
      .then((isConfirm) => {
        if (!isConfirm) return;

        fetch(url, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            "Accept": "application/json",
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            successDialog("Alḥamdulillāh", "Comment was successfully deleted!");

            this.fadeOutAndRemove(button.closest('li'));

            const newCount = parseInt(this.countTarget.textContent) - 1;
            this.countTarget.textContent = newCount;

            if (newCount === 0) {
              this.nocmtTarget.classList.remove('d-none');
            }
          } else {
            throw new Error('Server rejected the action.');
          }
        })
        .catch((error) => {
          console.error(error);
          errorDialog("Oops", "Something went wrong.");
        });
      });
  }

  fadeInAndShow(element) {
    if (element) {
      element.style.opacity = 0
      element.style.transition = "opacity 1s"
      requestAnimationFrame(() => {
        element.style.opacity = 1
      })
    }
  }

  fadeOutAndRemove(element) {
    element.style.transition = "opacity 0.5s";
    element.style.opacity = 0;

    setTimeout(() => {
      element.remove();
    }, 500); // match the 0.5s transition
  }
}
